import type { RouteState } from '../types';

const getRouteIdx = (route: RouteState, routes: RouteState[]) =>
  routes.findIndex(({ id }) => id === route.id);
const getPrevRoute = (route: RouteState, routes: RouteState[]) => {
  const routeIdx = getRouteIdx(route, routes);
  return routeIdx !== -1 && routeIdx > 0 ? routes[routeIdx - 1] : null;
};
const getNextRoute = (route: RouteState, routes: RouteState[]) => {
  const routeIdx = getRouteIdx(route, routes);
  return routeIdx !== -1 && routeIdx < routes.length - 1
    ? routes[routeIdx + 1]
    : null;
};

export const multiCityLib = {
  getRouteIdx,
  getPrevRoute,
  getNextRoute,
};
